import axios from "axios";
import { apiRoutes } from "../../../utils/constants";
import { popUp } from "../../../features/popUp/PopUp";
import { getAuthToken } from "../../sessionStorage/getAuthToken";

const updateCategories = async (values: any) => {
  const authInfo: any = getAuthToken();
  const data: any = JSON.parse(authInfo);
  let actualValues;
  let valuesData: any = {
    name: values.name,
    projectId: values.projectId,
  };

  if (values.image) {
    valuesData.image = values.image;
  }
  const formData = new FormData();
  Object.entries(valuesData).forEach(([key, value]: any) => {
    if (value instanceof File) {
      formData.append(key, value, value.name);
    } else {
      formData.append(key, value);
    }
  });
  actualValues = formData;
  return await axios[apiRoutes.UPDATE_CATEGORY.request](
    `${apiRoutes.UPDATE_CATEGORY.url}/${values.id}`,
    actualValues,
    {
      headers: {
        // "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${data.token}`,
        "Content-Type": "multipart/form-data",
      },
    }
  )
    .then((response: any) => {
      if (response.data) {
        return response.data;
      } else {
        popUp({
          type: "failure",
          message: "Oops! There was a problem in updateCategories",
        });
      }
    })
    .catch((error: any) => {
      console.log("error: ", error);
      const dataError = error.response.data.errors;
      if (dataError) {
        dataError.map((err: any) => {
          popUp({ type: "failure", message: err.message });
        });
      } else {
        popUp({ type: "failure", message: "Oh, something went wrong!" });
      }
    });
};

export default updateCategories;
